<template>
  <div v-if="(attributeValue.description!=='' && attributeValue.description!==null) || 
             (attributeValue.url!=='' && attributeValue.url!==null)">

      <tooltip :description="attributeValue.description"></tooltip>
  </div>   
</template>
<script>

import tooltip from './tooltip.vue'
import attribute from '../models/attribute.js'
export default {
    name: 'tooltipAttributeValue',
    props: {
        attributeValue:new attribute()
    },
    components:{tooltip}
}
</script>